<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-2 m-lg-3">
          <div class="card-body">
           
 <div class="row  align-items-center form-header">
            <div class="col mt-4">
              <h4 class="ms-md-2 ms-lg-4 ms-md-4">Donation Payments</h4>
            </div>
            
            <div class="col-12 col-sm-6 col-md-4 d-flex justify-content-end ">
              <llp-button
                classNames="btn-secondary new-btn d-none d-sm-block"
                @click="BackToServices()"
              >
                 Back To Donation Payments
              </llp-button>
               <llp-button
                classNames="btn-secondary new-btn d-block d-sm-none add-btn"
                 @click="BackToServices()"
              >
                Go Back
              </llp-button>
            </div>
          </div>
            <div class="m-lg-4 m-md-4" v-if="!DonationRoleId">
              <div class="col-lg-3 col-md-6 col-sm-12">
                <llp-label id="DonerLabel" :aria-label="confirPassword">
                 Organization Names:
                </llp-label>
                <select
                  id="state"
                  class="form-control select-dropdown"
                  v-model="SelectedName"
                >
                  <option value="" disabled selected>
                    Please select doner name
                  </option>
                  <option
                    v-for="details in donationPersonData"
                    :key="details.id"
                    :value="details.id"
                  >
                    {{ details.name }}
                  </option>
                </select>
              </div>
            </div>

            <div v-if="selectedDonationPerson" class="m-lg-4 m-md-4">
              <div class="col-lg-5 col-md-8 col-sm-12 selected-data">
                <h5>Selected Organization Details:</h5>
                <div class="card p-4">
                  <div class="row mb-2">
                    <div class="col-lg-6 col-md-6 col-sm-6"><strong>Name:</strong></div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      {{ selectedDonationPerson.name }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-6 col-md-6 col-sm-6"><strong>Address:</strong></div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      {{ selectedDonationPerson.address }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-6 col-md-6 col-sm-6"><strong>Pan Number:</strong></div>
                    <div class="col-lg-4 col-md-6 col-sm-6">{{ maskedPanNumber }}</div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-6 col-md-6 col-sm-6"><strong>Mobile:</strong></div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      {{ selectedDonationPerson.mobile }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                      <strong>Account Holder Name :</strong>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      {{ selectedDonationPerson.account_holder_name }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-6 col-md-6 col-sm-6"><strong>Bank Name :</strong></div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      {{ selectedDonationPerson.bank_name }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                      <strong>Account Number :</strong>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">{{ maskedAccountNumber }}</div>
                  </div>
                  <div class="col-lg-7 col-md-6 col-sm-12 mt-3">
                    <llp-label id="amountLabel" :aria-label="amount">
                      Amount:
                    </llp-label>
                    <llp-input
                      id="amountInputId"
                      class="w-100"
                      autocomplete="off"
                      v-model="this.Amount"
                       :errors="validator.Amount.$errors"
                    ></llp-input>
                  </div>
                  <div class="col-lg-7 col-md-6 col-sm-12 mt-3">
                    <llp-label id="emailLabelID" :aria-label="emailLabel">
                      Email(optional):
                    </llp-label>
                    <llp-input
                      id="emailInpuId"
                      class="w-100"
                      autocomplete="off"
                      v-model="email"
                    ></llp-input>
                  </div>
                  <div class="col-lg-7 col-md-6 col-sm-6 mt-2">
                    <llp-button
                      classNames="btn-secondary new-btn"
                      type="button"
                      @click:button="fetchPaymentMethods()"
                    >
                      Proceed To Pay
                    </llp-button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="DonationRoleId" class="m-lg-4 m-md-4">
              <div class="col-lg-5 col-md-8 col-sm-12">
                <h5>Selected Organization Details:</h5>
                <div class="card p-4">
                  <div class="row mb-2">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                      <strong>Name:</strong>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      {{ singleDonationPersonData.name }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                      <strong>Address:</strong>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      {{ singleDonationPersonData.address }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                      <strong>Pan Number:</strong>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      {{ maskedPanNumber }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                      <strong>Mobile:</strong>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      {{ singleDonationPersonData.mobile }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                      <strong>Account Holder Name :</strong>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      {{ singleDonationPersonData.account_holder_name }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                      <strong>Bank Name :</strong>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      {{ singleDonationPersonData.bank_name }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                      <strong>Account Number :</strong>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      {{ maskedAccountNumber }}
                    </div>
                  </div>
                  <div class="col-lg-7 col-md-6 col-sm-12 mt-3">
                    <llp-label id="amountLabel" :aria-label="amountLabel"
                      >Amount:</llp-label
                    >
                    <llp-input
                      id="amount"
                      class="w-100"
                      autocomplete="off"
                      v-model="this.Amount"
                       :errors="validator.Amount.$errors"
                    ></llp-input>
                  </div>
                  <div class="col-lg-7 col-md-6 col-sm-12 mt-3">
                    <llp-label id="emailLabel" :aria-label="confirPassword">
                      Email(optional):
                    </llp-label>
                    <llp-input
                      id="email"
                      class="w-100"
                      autocomplete="off"
                      v-model="email"
                    ></llp-input>
                  </div>
                  <div class="col-lg-7 col-md-6 col-sm-6 mt-2">
                    <llp-button
                      classNames="btn-secondary new-btn"
                      type="button"
                      @click:button="fetchPaymentMethods()"
                    >
                      Proceed To Pay
                    </llp-button>
                  </div>
                </div>
              </div>
            </div>
            <Dialog
              v-model:visible="showPaymentDialog"
              modal
              header="Select Payment Method"
              :style="{ width: '45rem' }"
               @hide="onHideDialog"
            >
              <div v-if="loading" class="loader-overlay">
                <div class="spinner"></div>
              </div>
              <span class="text-surface-500 dark:text-surface-400 block">
                Choose how you'd like to pay:
              </span>

              <div class="row mt-2">
                <div
                  class="col-6 mb-2"
                  v-for="method in paymentMethods"
                  :key="method.id"
                >
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      :id="method.id"
                      :value="method.value"
                      v-model="selectedPaymentMethod"
                      name="paymentOption"
                       @change="handlePaymentMethodChange(method.value)"
                    />
                    <label class="form-check-label ms-2" :for="method.id">
                      {{ method.name }}
                    </label>
                  </div>
                </div>
              </div>
        
              <div v-if="selectedPaymentMethod === 'Credit Card/Debit Card'">
                <h5>Card details:</h5>
                <div class="row">
                  <div class="mb-2 col-lg-6 col-md-6 col-sm-12">
                    <llp-label>Card Number:</llp-label>
                    <llp-input
                      v-model="cardDetails.cardNumber"
                      class="w-100 mb-2"
                      placeholder="Enter card number"
                      :errors="validator.cardDetails.cardNumber.$errors"
                       @input="formatCardNumber"
                    ></llp-input>
                  </div>
                </div>

                <div class="row">
                  <div class="mb-2 col-lg-6 col-md-6 col-sm-6">
                    <llp-label>Name on card</llp-label>
                    <llp-input
                      v-model="cardDetails.cardHolderName"
                      class="w-100 mb-2"
                      :errors="validator.cardDetails.cardHolderName.$errors"
                    />
                  </div>
                </div>
            
              </div>
    <div class="row" v-if="this.paymentCharges">
  <div class="col-6">
    <p class="mb-1"><strong>Amount:</strong></p>
    <p class="mb-3"><strong>Service Charge:</strong></p>
  </div>
  <div class="col-6">
    <p class="mb-1">₹{{ paymentCharges.base_amount }}</p>
    <p class="mb-3">₹{{ paymentCharges.charge_amount }}</p>
  </div>
                    </div>
              <div class="flex justify-end gap-2">
                <button
                  class="btn btn-secondary"
                  :load-spinner="payloadSpinner"
                  @click="PayAmount"
                >
                  Pay Now <span v-if="paymentCharges?.total_payable">(₹{{ paymentCharges.total_payable }})</span>

                </button>
              </div>
            </Dialog>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import NetworkService from "@/services/network.service";
import { useVuelidate } from "@vuelidate/core";
import Dialog from "primevue/dialog";
import _ from 'lodash';
import { cardValidation } from "@/validations/cardValidation";
import {
  formatCardNumber as formatCardNumberUtil,
 
} from "@/validations/cardFormatters";

export default {
  components: { Dialog },
  setup: () => ({ validator: useVuelidate() }),
  data() {
    return {
      SelectedName: "",
      DonationRoleId: this.$route.params.id,
      payloadSpinner: false,
      email: "",
      name: "",
      address: "",
      panNumber: "",
      mobile: "",
      Amount: "",
      loading: false,
        paymentCharges: null,
      selectedDonationPerson: "",
      serviceId: this.$route.params.serviceId,
      userId: localStorage.getItem("User_id"),
      role_id:localStorage.getItem('role_id'),
      donationPersonData: [],
      maskedPanNumber: "",
      maskedAccountNumber: "",
      singleDonationPersonData: [],
      paymentMethods: [],
      selectedPaymentMethod: "",
      donation_service_id: "",
      showPaymentDialog: false,
        lastCardDigits: "",
       debouncedFetchCharges: null,
       lastCardHolderName: "",
      cardDetails: {
        cardNumber: "",
        cardHolderName: "",
      },
    };
  },
 created() {
    this.debouncedFetchCharges = _.debounce(this.fetchPaymentCharges, 10000);
  },
  watch: {
     Amount(newVal) {
    if (newVal !== "") {
      this.validator.Amount.$touch();      
      this.validator.Amount.$validate();   
    }
  },
    SelectedName(newVal) {
      if (newVal) {
        this.fetchSelectedDonationPersonDetails(newVal);
      }
    },
     'cardDetails.cardNumber'() {
    this.tryFetchCharges();
  },
  'cardDetails.cardHolderName'() {
    this.tryFetchCharges();
  }
  },
  beforeUnmount() {
    if (this.debouncedFetchCharges) {
      this.debouncedFetchCharges.cancel();
    }
  },
  validations() {
    return cardValidation;
  },
  mounted() {
    const script = document.createElement("script");
    script.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
    script.async = true;
    document.head.appendChild(script);
    if (this.DonationRoleId) {
      this.fetchingSingleDonationPersonDetails();
    } else if (this.serviceId) {
      this.fetchingDonationUsers();
    }
  },

  methods: {
     formatCardNumber() {
        this.cardDetails.cardNumber = formatCardNumberUtil(this.cardDetails.cardNumber);
        this.validator.cardDetails.cardNumber.$touch();
      },
      onHideDialog() {
    NetworkService.resetPaymentDialog(this);
  },
     tryFetchCharges() {
  if (this.selectedPaymentMethod !== 'Credit Card/Debit Card') return;
  const cleanNumber = this.cardDetails.cardNumber.replace(/\D/g, '');
  const holderName = this.cardDetails.cardHolderName?.trim();
  if (cleanNumber.length === 16 && holderName) {
    if (this.lastCardDigits !== cleanNumber || this.lastCardHolderName !== holderName) {
      this.lastCardDigits = cleanNumber;
      this.lastCardHolderName = holderName;
      this.debouncedFetchCharges('Credit Card/Debit Card', {
        card_number: cleanNumber,
      });
    }
  } else {
    this.paymentCharges = null;
  }
},

    async fetchingDonationUsers() {
      try {
        const donationResponse = await NetworkService.get(
          `get-service-list-dropdown/${this.userId}/${this.serviceId}`
        );
        this.donationPersonData = donationResponse.details;
      } catch (error) {
        this.$refs.toast.show("Unable to fetch the user details.", "error");
      }
    },
    async fetchSelectedDonationPersonDetails(id) {
      try {
        this.donation_service_id = id;
        const response = await NetworkService.get(
          `get-service-list-for-pay/${id}/${this.userId}/${this.serviceId}`
        );
        this.selectedDonationPerson = response.details;
        // Optional: Mask PAN number

        this.maskedPanNumber = this.selectedDonationPerson.pan_number.replace(
          /.(?=.{4})/g,
          "*"
        );

        this.maskedAccountNumber =
          this.selectedDonationPerson.account_number.replace(/.(?=.{4})/g, "*");
        this.Amount = this.selectedDonationPerson.amount;
      
      } catch (error) {
        this.$refs.toast.show(
          "Failed to fetching the landlord details",
          "error"
        );
      }
    },

    async fetchingSingleDonationPersonDetails() {
      try {
        const singleUserResponse = await NetworkService.get(
          `get-service-list-for-pay/${this.DonationRoleId}/${this.userId}/${this.serviceId}`
        );
        this.singleDonationPersonData = singleUserResponse.details;

        this.maskedPanNumber = this.singleDonationPersonData.pan_number.replace(
          /.(?=.{4})/g,
          "*"
        );
        this.maskedAccountNumber =
          this.singleDonationPersonData.account_number.replace(
            /.(?=.{4})/g,
            "*"
          );
        this.Amount = this.singleDonationPersonData.amount;
      
      } catch (error) {
        this.$refs.toast.show(
          "Unable to fetching the salary person details.",
          "error"
        );
      }
    },
    async fetchPaymentMethods() {
      if (!this.selectedDonationPerson && !this.Amount) {
    this.validator.Amount.$touch(); 
    return;
  }
  if (this.selectedDonationPerson && !this.Amount) {
    this.validator.Amount.$touch(); 
    return;
  }
      this.showPaymentDialog = true;
       this.loading = true;
     try {
      this.paymentMethods = await NetworkService.getPaymentMethods();
      if (this.paymentMethods.length === 0) {
        this.$refs.toast.show("No payment methods available", "warning");
      }
    } catch (error) { 
      this.$refs.toast.show("Unable to fetch the payment methods", "error");
    } finally {
      this.payloadSpinner = false;
      this.loading = false;
    }
    },
  handlePaymentMethodChange(methodValue) {
    
    this.selectedPaymentMethod = methodValue;
    this.paymentCharges = null;
    this.cardDetails.cardNumber = '';
    this.cardDetails.cardHolderName = '';
     if (this.validator?.cardDetails?.cardNumber) {
    this.validator.cardDetails.cardNumber.$reset();
  }
  if (this.validator?.cardDetails?.cardHolderName) {
    this.validator.cardDetails.cardHolderName.$reset();
  }
   if (methodValue !== 'Credit Card/Debit Card') {
    this.fetchPaymentCharges(methodValue);
  }
  },
    async fetchPaymentCharges(methodValue,extra ={}) {
        this.debouncedFetchCharges.cancel();
    if (!methodValue) return;
    this.loadingCharges = true;
    this.loading = true;
    try {
      const method = this.paymentMethods.find(m => m.value === methodValue);
      if (!method) {
        throw new Error('Payment method not found');
      }
      const baseAmount = this.selectedDonationPerson 
        ? this.Amount 
        : this.Amount;
 const payload = {
          user_id: this.userId,
          method_type: methodValue,
          base_amount: baseAmount,
          ...extra              
        };
      const response = await NetworkService.getPaymentCharges(method.id, this.role_id, payload);
   if (response.success === false) {
          this.$refs.toast.show(
            response.message || 'Unable to fetch payment charges',
            'error'
          );
          return;
        }
        this.paymentCharges = response;
         this.loading = false;
      } catch (err) {
        const msg =
          err?.response?.data?.message || err.message || 'Failed to fetch charges';
        this.$refs.toast.show(msg, 'error');
    } finally {
      this.loadingCharges = false;
         this.loading = false;
    }
  },
    async PayAmount() {
      if (!this.selectedPaymentMethod) {
        this.$refs.toast.show("Please select a payment method", "error");
        return;
      }

      if (this.selectedPaymentMethod === "Credit Card/Debit Card") {
        const isValid = await this.validator.$validate();
        if (!isValid) return;
      }

      this.payloadSpinner = true;

      try {
        const selectedMethod = this.paymentMethods.find(
          (method) => method.value === this.selectedPaymentMethod
        );

        const paymentDetails = this.selectedDonationPerson
          ? {
              user_id: this.userId,
              base_amount: this.Amount,
              service_id: this.serviceId,
              email: this.email,
              mobile: this.selectedDonationPerson.mobile,
              name: this.selectedDonationPerson.name,
              payment_method_id: selectedMethod.id,
              service_user_id: this.donation_service_id,
              account_number: this.selectedDonationPerson.account_number,
              account_holder_name:
              this.selectedDonationPerson.account_holder_name,
              bank_name: this.selectedDonationPerson.bank_name,
              bank_branch: this.selectedDonationPerson.bank_branch,
              ifsc_code: this.selectedDonationPerson.ifsc_code,
              beneficiary_id: this.selectedDonationPerson.beneficiary_id,
              charge_amount:this.paymentCharges.charge_amount,
              amount:this.paymentCharges.total_payable,
              method_type:this.selectedPaymentMethod,
              charge_percent:this.paymentCharges.charge_percent
            }
          : {
              user_id: this.userId,
              base_amount: this.Amount,
              email: this.email,
              mobile: this.singleDonationPersonData.mobile,
              name: this.singleDonationPersonData.name,
              service_id: this.serviceId,
              payment_method_id: selectedMethod.id,
              service_user_id: this.rentalRoleId,
              account_number: this.singleDonationPersonData.account_number,
              account_holder_name:
                this.singleDonationPersonData.account_holder_name,
              bank_name: this.singleDonationPersonData.bank_name,
              bank_branch: this.singleDonationPersonData.bank_branch,
              ifsc_code: this.singleDonationPersonData.ifsc_code,
              beneficiary_id: this.singleDonationPersonData.beneficiary_id,
              charge_amount:this.paymentCharges.charge_amount,
              amount:this.paymentCharges.total_payable,
              method_type:this.selectedPaymentMethod,
              charge_percent:this.paymentCharges.charge_percent
            };

        const result = await NetworkService.PaymentService.initiate(
          `get-payment-gateways-for-pay`,
          selectedMethod.id,
          paymentDetails
        );
if (result.selected_method === 'auropay' && result?.order?.paymentLink) {
  window.location.href = result.order.paymentLink;
  return;
}
const paymentSessionId = result?.order?.data?.payment_session_id;

        if (paymentSessionId) {
          const cashfreeResult =
            await NetworkService.PaymentService.processCashfree(
              paymentSessionId
            );
          console.log("cashfreeResult", cashfreeResult);
          this.loading = true;
          setTimeout(async () => {
            await this.verifyPaymentStatus(result.order.data.order_id);
          }, 5000);
          // setTimeout(() => {
          //   this.loading = false;
          //   this.$router.push({
          //     name: "PaymentStatus",
          //     params: { order_id: result.order_id },
          //   });
          // }, 3000);
        } else {
          throw new Error("No payment session ID received from server");
        }
      } catch (error) {
        this.payloadSpinner = false;
        const errorInfo = NetworkService.PaymentService.handleError(error);
        if (this.$refs.toast) {
          this.$refs.toast.show(
            errorInfo.message || "Something went wrong",
            "error"
          );
        }
      }
    },

    // async verifyPaymentStatus(orderId) {
    //   this.loading = false;
    //   try {
    //     const status = await NetworkService.PaymentService.verifyStatus(
    //       orderId
    //     );

    //     console.log("status..........", status);

    //     if (status === "SUCCESS") {
    //       this.$refs.toast.show("Payment successful", "success");
    //       this.loading = false;
    //       setTimeout(() => {
    //         this.$router.push({ name: "ThankYou" });
    //       }, 3000);
    //     } else if (status === "FAILED") {
    //       setTimeout(() => {
    //         this.loading = false;
    //         this.$refs.toast.show("Payment failed", "error");
    //       }, 3000);
    //     } else if (status === "PENDING") {
    //       setTimeout(() => {
    //         this.loading = false;
    //         this.$refs.toast.show("Payment is still pending", "info");
    //       }, 3000);
    //     } else {
    //       this.loading = false;
    //       this.$refs.toast.show("Payment Failed", "error");
    //     }
    //   } catch (error) {
    //     this.loading = false;
    //     const errorInfo = NetworkService.PaymentService.handleError(error);
    //     this.$refs.toast.show(errorInfo.message, "error");
    //   }
    // },
async verifyPaymentStatus(orderId) {
  await NetworkService.PaymentService.verifyAndHandlePaymentStatus(orderId, this);
},
    BackToServices() {
      this.$router.back();
    },
  },
};
</script>
